<template>
    <el-row :gutter="16" class="inspection-grid">
  <!-- LEFT: Nội dung bài -->
  <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
    <InspectionContent :detail="detail" />
  </el-col>

  <!-- RIGHT: Đánh giá chất lượng -->
  <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
    <div class="right-wrap">
      <InspectionEvaluate
        ref="evaluate"
        :form="form"
        :saving="saving"
        :activeTab="activeTab"
        :isShowMode="isShowMode"
        :currentSupplementIndex="currentSupplementIndex"
        :supplementDetailLength="supplementDetailLength"
        :isSupplementFormDirty="isSupplementFormDirty"
        :isMainFormDirty="isMainFormDirty"
        @update:form="$emit('update:form', $event)"
        @save="$emit('save')"
        @goBack="$emit('goBack')"
        @goNext="$emit('goNext')"
      />
    </div>
  </el-col>
</el-row>
  </template>
  
  <script>
  import InspectionContent from './InspectionContent.vue'
  import InspectionEvaluate from './InspectionEvaluate.vue'
  
  export default {
    name: 'InspectionSection',
    components: { InspectionContent, InspectionEvaluate },
    props: {
      detail: { type: Object, default: null },
      form: { type: Object, required: true },
      saving: { type: Boolean, default: false },
      activeTab: { type: String, default: 'main' },
      isShowMode: { type: Boolean, default: false },
      currentSupplementIndex: { type: Number, default: 0 },
      supplementDetailLength: { type: Number, default: 0 },
      isSupplementFormDirty: { type: Boolean, default: false },
      isMainFormDirty: { type: Boolean, default: false }
    },
    model: { prop: 'form', event: 'update:form' }
  }
  </script>
  
  <style scoped>
  .inspection-grid { margin-top: 8px; }
  
  .right-wrap { position: sticky; top: 12px; }
  
  .inspection-grid >>> .el-col,
  .inspection-grid /deep/ .el-col { display: block; }
  
  .inspection-grid >>> .el-row,
  .inspection-grid /deep/ .el-row { box-sizing: border-box; }
  
  @media (max-width: 991.98px) {
    .right-wrap { position: static; top: auto; margin-top: 12px; }
  
    .right-wrap >>> .sticky,
    .right-wrap /deep/ .sticky { position: static; top: auto; }
  }
  </style>
  
  